import React from 'react';
import Suggester from 'src/components/Suggester';
import { useSuggestions } from 'src/hooks/useSuggestions';
import { MPEvents } from 'src/utils/mixpanel/types';
import { mpEvent } from 'src/utils/mixpanel';
import { WizardRecomendedControlsIntent } from 'src/redux/reducers/app/types';
import useActionsApp from 'src/redux/actionHooks/useActionsApp';
interface AiSuggestScenarioProps {
  wrapperStyle?: React.CSSProperties;
  assessment: { id: string; name: string };
}

export const AiSuggestScenario: React.FC<AiSuggestScenarioProps> = ({ wrapperStyle, assessment }) => {
  const { saveKeys, hiddenSuggestionKeys } = useSuggestions();
  const id = `${assessment.id}-scenario`;
  const isHidden = !!id && hiddenSuggestionKeys.includes(id);
  const { setWizardRecomendedControls } = useActionsApp();

  if (isHidden) return null;

  return (
    <div style={wrapperStyle}>
      <Suggester
        key={id}
        onClose={() => {
          const newKeys = [...hiddenSuggestionKeys, id];
          saveKeys(newKeys);
        }}
        title={
          <span>
            Add{' '}
            <span
              className="sg-action"
              onClick={() => {
                setWizardRecomendedControls({
                  intent: {
                    type: WizardRecomendedControlsIntent.addScenarios,
                    params: { assessmentId: assessment.id, assessmentName: assessment.name },
                  },
                });

                mpEvent(MPEvents.ButtonClick, {
                  button: 'Suggested scenarios',
                  tags: ['ASSESSMENT', 'SCENARIO', 'AI'],
                });
              }}
            >
              scenarios
            </span>{' '}
            to this assessment.
          </span>
        }
      />
    </div>
  );
};
